// Generated using typescript-generator version null on 2019-12-06 10:18:54.

import { NeqHttpClient as HttpClient } from './http-client.config';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { FacultativeNutrientDto } from '@sharedcommon/model/facultative-nutirent.model';
import { CalculationStatus } from '@sharedcommon/model/calculation-status.model';
import { FloorCeilCalculationService } from './floor-ceil-calculation.service';
import { ResultColumnDto } from '@sharedcommon/model/result-column.model';
import {FormGroup} from '@angular/forms';
import { URN } from '@sharedcommon/model/urn.model';
import { ImportType } from '@sharedcommon/model/import-type.model';
import { SharedPagedRequest } from '@sharedcommon/model/shared-page-request.model';
import { SharedPagedResponse } from '@sharedcommon/model/shared-paged-response.model';
import { AnalysisOriginDto } from '@sharedcommon/model/sample/analysis-origin.model';
import { RawMaterialPatchDto } from '@sharedcommon/model/rawmaterial-patch.model';
import { RawmaterialOrSampleStatus } from '@sharedcommon/util/rawmaterial-or-sample-status.utils';
import { SampleResultColumnFilterDto } from '@sharedcommon/model/sample-result-column-filter.model';
import { environment } from '@sharedenvironment';

export class TechnicalMetaDto {
  key?: string;
  value?: string;
}

export class DataResultColumnFilterDto {
  computeId: string ;
  rawMaterialId: string ;
  matrixCode: string ;
  ceilOrFloorReached: boolean;
}

export class CalculatedResultFilterDto extends SharedPagedRequest {
  nutrientCodes?: string[];
  filled?: boolean;
  nutrientCalculated?: boolean;
  classId?: string;
  rawMatId?: string;
}

export class DomainTranslateDto {
  codeLang?: string;
  labelLang?: string;
  elementTranslateLabel?: string;
  elementTranslateDescription?: string;
}

export class ClassNutrientFilterDto extends SharedPagedRequest {
  code?: string;
  name?: string;
}

export class AbstractAuditableDto {
  modifiedBy?: string;
  modificationDate?: any;
}

export class ClassNutrientDto extends AbstractAuditableDto {
  id?: string;
  activity?: URN;
  code?: string;
  name?: string;
}

export class CoherenceCalcRequestDto {
  referenceId: string;
  predictionModelId: string;
  inputs?: CoherenceCalcRequestInputDto[];
}

export class CoherenceCalcRequestInputDto {
  facet: URN;
  value?: number|string;
  filled?: boolean;
}

export class CoherenceEquationDto extends AbstractAuditableDto {
  id?: string;
  label?: string;
  activity?: URN;
  formula?: string;
  notes?: string;
}

export class CoherenceEquationFilterDto extends SharedPagedRequest {
  label?: string;
  activityCode?: number;
}

export class PrepareResultDto {
  variablesRequired?: string[];
  otherFacets?: string[];
}

export class ComputeDto {
  id: string;
  status: Status;
  report: string;
  results: ComputeResultDto[];
  createdBy: string;
  creationDate: any;
  calculationStatus: CalculationStatus ;
  forcedCalcStatus: boolean ;
}

/* The DTO send after a calculation */
export class ComputeWithMetaDataDto extends ComputeDto {
  /** Indicates if the error is caused by an equation which contains an entry
   * nutrient which is facultative with a null value */
  facultativeNutError: boolean ;
  /** The exception details in case of facultativeNutError */
  facultativeErrorDetail: string ;
}

export class ComputeFilterDto extends SharedPagedRequest {
  status?: Status;
}

export class DomainRightFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
  hasRightForEntity?: boolean;
  hasRightForEntityModel?: boolean;
  entityModelCode?: string;
  entityCode?: string;
}

export class DomainRightNutrientFilterDto extends DomainRightFilterDto {
  classNutrientLabel?: string;
}

export class DomainRightPatchDto {
  idDomain: string;
  entityCode?: string;
  hasRight?: boolean;
}

export class DomainRightPredictionModelFilterDto extends DomainRightFilterDto {
  levelCode?: string;
}

export class DomainRightReferenceFilterDto extends DomainRightFilterDto {
  predictionModelCode?: string;
  predictionModelLabel?: string;
  hasPredictionModelRightForEntity?: boolean;
  hasPredictionModelRightForEntityModel?: boolean;
  levelCode?: string;
}

export class ClassDto extends AbstractAuditableDto {
  id?: string;
  code?: string;
  label?: string;
  meta: boolean;
  sort?: number;
  listNutrientClasses?: ClassNutrientDto[];
  placementBeforeClass?: boolean;
  classPlacement?: ClassNutrientDto;
}

export class ClassFilterDto extends SharedPagedRequest {
  label?: string;
  code?: string;
  meta?: boolean;
}

export class PatchClassesDto {
  orderedClassesCode?: string[];
  listPatchForClass?: PatchClassDto[];
}

export class HttpEntity<T> {
  headers?: { [index: string]: any };
  body?: T;
}

export class ResponseEntity<T> extends HttpEntity<T> {
  statusCodeValue?: number;
  statusCode?: HttpStatus;
}

export class PredictionModelFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
  global?: string;
  inLevelIds?: string[];
  levelOne?: string;
  levelTwo?: string;
  levelThree?: string;
}

export class JobStatusInfo {
  status?: JobStatus;
  progress?: number;
  step?: string;
}

export class RawMaterialDto extends AbstractAuditableDto {
  id?: string;
  activity?: URN;
  code?: string;
  entity?: URN;
  entityLabel?: string;
  label?: string;
  referenceId: string;
  referenceLabel?: string;
  referencePredictionModelLabel?: string;
  notes?: string;
  lockUserFullName?: string;
  lockUserBy?: string;
  lockDate?: any;
  calculationBy?: string;
  calculationDate?: any;
  calculationStatus?: CalculationStatus;
  exportBy?: string;
  exportDate?: any;
  status?: RawmaterialOrSampleStatus;
  forcedCalcStatus?: boolean;
  importType?: ImportType;
  disabledBy?: string;
  archivedBy?: string;
}

export class RawMaterialSaveDto {
  rawMaterialDtos: RawMaterialDto[];
  rawMaterialNutrientSaveDtos: RawMaterialNutrientSaveDto[];
}

export class RawMaterialNutrientSaveDto {
  rawMaterialId: string;
  nutrientCode: string;
  value: number;
}

export class ExportResponseDto {
  activityCode?: string;
  entityCode?: string;
  matrixCode?: string;
  nutrients?: ExportNutrientDto[];
  rawMaterials?: ExportRawMaterialDto[];
}

export class ExportRequestDto {
  refreshToken?: string;
  rawMaterialsCodes?: EntityRawMaterialsDto[];
}

export class ExportMultiFormatRequestDto {
  refreshToken?: string;
  rawMaterialsCodes?: EntityRawMaterialsDto[];
  exportFormatList?: string[];
}

export class RawMaterialFilterDto extends SharedPagedRequest {
  rawMatId?: string;
  code?: string;
  codes?: string[];
  label?: string;
  reference?: string;
  predictionModel?: string;
  startCalculation?: Date|string;
  endCalculation?: Date|string;
  calculationBy?: string;
  global?: string;
  referenceId?: string;
  predictionModelId?: string;
  levelId?: string;
  entityCode?: string;
  entityLabel?: string;
  entitiesAssociated?: EntityDto[];
  startCalculationDate?: any;
  endCalculationDate?: any;
  archive?:boolean;
  waitingForCalculation?:boolean;
  desarchive?:boolean;
  disabled?:boolean;
  ids?:string[];
}

export class ReportDto {
  matrices?: string[];
  classes?: string[];
  note?: boolean;
}

export class GenericResultFilterDto {
  classNutIds?: string[];
  metaClassNutIds?: string[];
  resultDetails?: string[];
}

export class ResultFilterDto extends GenericResultFilterDto {
  computeId?: string;
}

export class SampleResultFilterDto extends GenericResultFilterDto {
  tempCalculationId?: string;
}

export class ReferenceFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
  predictionModel?: string;
  inPredictionModelIds?: string[];
  inLevelIds?: string[];
}

export class ReferenceDto extends AbstractAuditableDto {
  id?: string;
  activity?: URN;
  code?: string;
  label?: string;
  description?: string;
  predictionModelId: string;
  predictionModelCode?: string;
  predictionModelLabel?: string;
  predictionModelDescription?: string;
  coherenceEquationId?: string;
  coherenceVariable1?: number;
  coherenceVariable2?: number;
  coherenceVariable3?: number;
  coherenceVariable4?: number;
  coherenceVariable5?: number;
  coherenceTolerance?: number;
  notes?: string;
}

export class LevelDto extends AbstractAuditableDto {
  id?: string;
  activity?: URN;
  code?: string;
  label?: string;
  parentId?: string;
  children?: LevelDto[];
  parent?: LevelDto;
}

export class LevelFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
  depth?: number;
  withChildren?: boolean;
  parentId?: string;
  minDepth?: number;
}

export class NutrientDto extends AbstractAuditableDto {
  id?: string;
  activity?: URN;
  code?: string;
  label?: string;
  description?: string;
  classNutrientId: string;
  classNutrientCode?: string;
  calculated?: boolean;
  optional?: boolean;
  unit?: string;
  decimal: number;
  tolerancePercentage?: number;
  toleranceMin?: number;
  toleranceMax?: number;
  technicalityDegree?: number;
  notes?: string;
  order?: string;
  minVal: number;
  maxVal: number;
  limitable: boolean ;
  cappable: boolean ;
  facultative: boolean ;
  standardVal: number;
  placementBefore?: boolean;
  nutrientPlacement?: NutrientDto;
  technicalDocAvailable?: boolean;
  technicalDocFormat?: string;
}

export class NutrientFilterDto extends SharedPagedRequest {
  code?: string;
  codes?: string[];
  label?: string;
  classNutrient?: string;
  calculated?: boolean;
  facultative: boolean;
  optional?: boolean;
}

export interface AsyncResponse {
  cancelled?: boolean;
  suspended?: boolean;
  done?: boolean;
}

export class PredictionModelDto extends AbstractAuditableDto {
  id?: string;
  activity?: URN;
  code?: string;
  label?: string;
  description?: string;
  technicalityDegree?: number;
  notes?: string;
  levelId?: string;
  technicalDocAvailable?: boolean;
  technicalDocFormat?: string;
  levelOne?: string;
  levelTwo?: string;
  levelThree?: string;
}

export class OptionalNutrientFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
  predictionModelId?: string;
}

export class FacultativeNutrientFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
  predictionModelId?: string;
}

export class VariableValueDto extends AbstractAuditableDto {
  predictionModelId?: string;
  variable?: URN;
  value?: string;
}

export class VariableValueFilterDto extends SharedPagedRequest {
  variableCodes?: string[];
  predModCodes?: string[];
  predictionModelId?: string;
}

export class ReferenceValueFilterDto extends SharedPagedRequest {
  nutrientCodes?: string[];
  validNutrient?: boolean;

  /** Indicates if we expect calculated or entry reference only */
  forCalculated?: boolean ;
}

export class ReferenceValueDto extends AbstractAuditableDto {
  referenceId?: string;
  nutrientId?: string;
  nutrientCode?: string;
  label?: string;
  unit?: string;
  minVal?: number;
  maxVal?: number;
  floorVal?: number;
  ceilVal?: number;
  standardVal?: number;
  nutrientOrder?: string;
  nutrientRequired?: boolean;
  minDefault?: number;
  maxDefault?: number;
  standardDefault?: number;

  /** Indicates if the referenceValue is limitable or not */
  limitable: boolean ;
  /** Indicates if nutrient connected to ReferenceValue is limitable */
  limitableNutrient: boolean ;

  /** Indicates if the referenceValue is cappable or not */
  cappable: boolean ;
  /** Indicates if nutrient connected to ReferenceValue is cappable */
  cappableNutrient: boolean ;
}

export class ReferenceValueAndFormForCal {
  /** La référence value dont provient l'objet */
  referenceValue: ReferenceValueDto;

  /** Le formulaire qui sera utilisé dans le composant */
  form: FormGroup ;
}

export class TranslateClassNutrientFilterDto extends SharedPagedRequest {
  code?: string;
  name?: string;
  langModel?: string;
  toTranslateLang: string;
  toTranslateLabelEmpty?: boolean;
}

export class TranslateDto {
  id: string;
  lang?: string;
  translation?: string;
  field?: string;
}

export class TranslateLevelFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
  langModel?: string;
  toTranslateLang: string;
  toTranslateLabelEmpty?: boolean;
}

export class EntityRightFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
}

export class TranslateNutrientFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
  langModel?: string;
  toTranslateLang: string;
  classNutrient?: string;
  toTranslateLabelEmpty?: boolean;
  toTranslateDescriptionEmpty?: boolean;
}

export class TranslatePredictionModelFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
  langModel?: string;
  toTranslateLang: string;
  level?: string;
  translateToLabelEmpty?: boolean;
  translateToDescriptionEmpty?: boolean;
}

export class TranslateReferenceFilterDto extends SharedPagedRequest {
  code?: string;
  label?: string;
  predictionModelCode?: string;
  predictionModelLabel?: string;
  level?: string;
  langModel?: string;
  toTranslateLang: string;
  toTranslateLabelEmpty?: boolean;
  toTranslateDescriptionEmpty?: boolean;
}

export class VariableValueImportParamsDto {
  csv?: string;
  importPredictionModelsCode?: string[];
  overridePredictionModelsCode?: string[];
}

export class VariableValueImportPreviewDto {
  missingPredictionModels?: string[];
  predictionModels?: VariableValueImportPredModPreviewDto[];
}

export class CalculatedResultDto extends AbstractAuditableDto {
  rawMaterialId?: string;
  nutrientId?: string;
  nutrientCode?: string;
  matrix?: URN;
  value?: number;
  cappedVal?: number;
  ceilOrFloorReached?: number;
  ceilVal?: number;
  floorVal?: number;
  filled?: boolean;
}

export class ComputeResultDto {
  id?: string;
  computeId?: string;
  rawMaterialId: string;
  nutrientId?: string;
  nutrientCode?: string;
  matrix: URN;
  value: number;
  cappedVal: number ;
  ceilOrFloorReached: boolean ;
  ceilVal: number ;
  floorVal: number ;
  standard?: boolean;
  filled?: boolean;
}

export class DomainRightDto {
  idDomain?: string;
  code?: string;
  label?: string;
  hasRightForEntity?: boolean;
  hasRightForEntityModel?: boolean;
}

export class DomainRightNutrientDto extends DomainRightDto {
  order?: string;
  classNutrientLabel?: string;
}

export class DomainRightReferenceDto extends DomainRightDto {
  predictionModelCode?: string;
  predictionModelLabel?: string;
  hasPredictionModelRightForEntity?: boolean;
  hasPredictionModelRightForEntityModel?: boolean;
  predictionModelId?: string;
}

export class PatchClassDto {
  classCode?: string;
  orderedNutrientsCode?: string[];
}

export class JobDto {
  id?: string;
  userId?: string;
  status?: JobStatus;
  progress?: number;
  step?: string;
  type?: string;
  name?: string;
  creationDate?: any;
  startDate?: any;
  endDate?: any;
}

export class EntityRawMaterialsDto {
  entityCode?: string;
  rmCodes?: ExportRawMaterialCodeDto[];
}

export class ExportNutrientDto {
  nutCode?: string;
  nutName?: string;
  nutUnit?: string;
}

export class ExportRawMaterialDto {
  rmCode?: string;
  rmName?: string;
  rmSaved?: any;
  rmSavedByUser?: string;
  rmSavedByEntity?: string;
  nutrients?: ExportNutrientValueDto[];
}

export class EntityDto extends AbstractAuditableDto {
  id?: string;
  code?: string;
  name?: string;
  logo: string;
  principalMatrix: URN;
  principalMatrixId: string;
  hasSearchedUser?: boolean;
  rawmatExportEnabled?: boolean;
  rawmatExportFormat?: string;
  rawmatExportList?: string;
}

export class RawMaterialNutrientDto {
  nutrientCode?: string;
  label?: string;
  description?: string;
  required?: boolean;
  unit?: string;
  value?: number;
  filled?: boolean;
  predictor?: boolean;
  decimal?: number;
  min?: number;
  max?: number;
  ceilVal: number ;
  floorVal: number ;
  cappableNutrient: number ;
  cappableRefVal: number ;
  standard?: number;
  minTolerance?: number;
  maxTolerance?: number;
  percentageTolerance?: number;
  technicalDocAvailable?: boolean;
  technicalDocFormat?: string;
  facultativeInput: boolean ;
}

export class SampleNutrientDto extends RawMaterialNutrientDto {
  analysisOrigin: AnalysisOriginDto;
}

export class ResultDto {
  nutrientId?: string;
  nutrientCode?: string;
  nutrientLabel?: string;
  nutrientDescription?: string;
  nutrientUnit?: string;
  decimal?: number;
  values?: number[];
  cappedValues?: number[];
  limitableValuesRefVal: boolean[] ;
  ceilValues?: number[];
  floorValues?: number[];
  standardFlags?: boolean[];
  allCeilOrFloorReached?: boolean[] ;
  technicalDocAvailable?: boolean;
  technicalDocFormat?: string;
}

export class OptionalNutrientDto extends AbstractAuditableDto {
  id?: string;
  order?: string;
  code?: string;
  label?: string;
  available?: boolean;
}

export class PatchDto<T> {
  op?: PatchOperation;
  path?: string;
  value?: T;
  from?: string;
}

export class TranslateClassNutrientDto {
  id?: string;
  code?: string;
  name?: string;
  modelLabel?: string;
  toTranslateLabel?: string;
}

export class TranslateLevelDto {
  id?: string;
  code?: string;
  label?: string;
  modelLabel?: string;
  toTranslateLabel?: string;
}

export class EntityRightDto {
  elementId?: string;
  entity?: URN;
  entityLabel?: string;
  hasRight?: boolean;
}

export class TranslateNutrientDto {
  id?: string;
  code?: string;
  label?: string;
  description?: string;
  classNutrientId?: string;
  classNutrientCode?: string;
  classNutrientLabel?: string;
  modelLabel?: string;
  modelDescription?: string;
  toTranslateLabel?: string;
  toTranslateDescription?: string;
  order?: string;
}

export class TranslatePredictionModelDto {
  id?: string;
  code?: string;
  label?: string;
  description?: string;
  levelId?: string;
  levelCode?: string;
  levelLabel?: string;
  modelLabel?: string;
  modelDescription?: string;
  toTranslateLabel?: string;
  toTranslateDescription?: string;
}

export class TranslateReferenceDto {
  id?: string;
  code?: string;
  label?: string;
  description?: string;
  predictionModelId?: string;
  predictionModelCode?: string;
  predictionModelLabel?: string;
  levelId?: string;
  levelCode?: string;
  levelLabel?: string;
  modelLabel?: string;
  modelDescription?: string;
  toTranslateLabel?: string;
  toTranslateDescription?: string;
}

export class VariableValueImportPredModPreviewDto {
  predictionModel?: PredictionModelDto;
  lines?: number;
  imported?: number;
  overwritten?: number;
  errors?: string[];
}

export class ExportRawMaterialCodeDto {
  rmCode?: string;
}

export class ExportNutrientValueDto {
  nutCode?: string;
  nutValue?: number;
}

export class ImportFullAutoDto {
  format: string ;
  csvFileName: string;
  csvContent: string ;
}

@Injectable()
export class TechnicalServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * HTTP GET /technical/metas/{key}
   * Java method: com.neovia.equadvice.common.service.TechnicalService.getMeta
   */
  getMeta(key: string): RestResponse<TechnicalMetaDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`technical/metas/${key}` });
  }

  /**
   * HTTP GET /technical/rights
   * Java method: com.neovia.equadvice.common.service.TechnicalService.getRights
   */
  getRights(): RestResponse<string[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`technical/rights` });
  }
}

@Injectable()
export class CalculatedResultServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Delete matrix
   * Response code 202 - Deleted
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP DELETE /calculated_results/matrix/{matrix_code}
   * Java method: com.neovia.equadvice.data.service.CalculatedResultService.deleteByMatrix
   */
  deleteByMatrix(matrix_code: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`calculated_results/matrix/${matrix_code}` });
  }

  /**
   * Get filtered & paged calculatedResults
   * Response code 206 - Partial ranged calculatedResults
   * Response code 404 - Not found
   * HTTP GET /calculated_results
   * Java method: com.neovia.equadvice.data.service.CalculatedResultService.fetch
   */
  fetch(arg0: CalculatedResultFilterDto): RestResponse<SharedPagedResponse<CalculatedResultDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`calculated_results`, data: arg0 });
  }
}

@Injectable()
export class ClassNutrientServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Get filtered & paged class nutrient translates
   * Response code 206 - Partial ranged class nutrient translates
   * Response code 404 - Not found
   * HTTP GET /class_nutrients/{classNutrientId}/translates
   * Java method: com.neovia.equadvice.data.service.SubClassNutrientDomainTranslateService.translatesFetch
   */
  translatesFetch(classNutrientId: string): RestResponse<DomainTranslateDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`class_nutrients/${classNutrientId}/translates` });
  }

  /**
   * Patch class nutrient translate
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP PATCH /class_nutrients/{classNutrientId}/translates
   * Java method: com.neovia.equadvice.data.service.SubClassNutrientDomainTranslateService.translatesPatch
   */
  translatesPatch(classNutrientId: string, arg1: DomainTranslateDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`class_nutrients/${classNutrientId}/translates`, data: arg1 });
  }

  /**
   * Get all classnutrients
   * Response code 200 - Partial ranged classnutrients
   * Response code 404 - Not found
   * HTTP GET /class_nutrients
   * Java method: com.neovia.equadvice.data.service.ClassNutrientService.fetch
   */
  fetch(arg0: ClassNutrientFilterDto): RestResponse<SharedPagedResponse<ClassNutrientDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`class_nutrients`, data: arg0 });
  }

  /**
   * Get classNutrient by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /class_nutrients/{id}
   * Java method: com.neovia.equadvice.data.service.ClassNutrientService.get
   */
  get(id: string, queryParams?: { translated?: boolean; }): RestResponse<ClassNutrientDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`class_nutrients/${id}`, queryParams: queryParams });
  }
}

@Injectable()
export class CoherenceEquationServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Calculate coherence value
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP POST /equation_coherence/calculate
   * Java method: com.neovia.equadvice.data.service.CoherenceEquationService.calculate
   */
  calculate(arg0: CoherenceCalcRequestDto): RestResponse<number> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`equation_coherence/calculate`, data: arg0 });
  }

  /**
   * Create coherence equation
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /equation_coherence
   * Java method: com.neovia.equadvice.data.service.CoherenceEquationService.create
   */
  create(arg0: CoherenceEquationDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`equation_coherence`, data: arg0 });
  }

  /**
   * Delete coherence equation
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /equation_coherence/{id}
   * Java method: com.neovia.equadvice.data.service.CoherenceEquationService.delete
   */
  delete(id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`equation_coherence/${id}` });
  }

  /**
   * Get all coherence's equations
   * Response code 200 - Partial ranged coherence equation
   * Response code 404 - Not found
   * HTTP GET /equation_coherence
   * Java method: com.neovia.equadvice.data.service.CoherenceEquationService.fetch
   */
  fetch(arg0: CoherenceEquationFilterDto): RestResponse<SharedPagedResponse<CoherenceEquationDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`equation_coherence`, data: arg0 });
  }

  /**
   * Get coherence equation by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /equation_coherence/{id}
   * Java method: com.neovia.equadvice.data.service.CoherenceEquationService.get
   */
  get(id: string): RestResponse<CoherenceEquationDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`equation_coherence/${id}` });
  }

  /**
   * Prepare coherence value
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP POST /equation_coherence/prepare
   * Java method: com.neovia.equadvice.data.service.CoherenceEquationService.prepare
   */
  prepare(arg0: CoherenceCalcRequestDto): RestResponse<PrepareResultDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`equation_coherence/prepare`, data: arg0 });
  }

  /**
   * Update coherence equation
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PUT /equation_coherence
   * Java method: com.neovia.equadvice.data.service.CoherenceEquationService.put
   */
  put(arg0: CoherenceEquationDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`equation_coherence`, data: arg0 });
  }
}

@Injectable()
export class ComputeServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create compute
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /computes
   * Java method: com.neovia.equadvice.data.service.ComputeService.create
   */
  create(arg0: ComputeDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`computes`, data: arg0 });
  }

  /**
   * Delete compute
   * Response code 204 - Modify
   * Response code 500 - Error
   * HTTP DELETE /computes/{id}
   * Java method: com.neovia.equadvice.data.service.ComputeService.delete
   */
  delete(id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`computes/${id}` });
  }

  /**
   * Get filtered & paged compute
   * Response code 206 - Partial ranged computes
   * Response code 404 - Not found
   * HTTP GET /computes
   * Java method: com.neovia.equadvice.data.service.ComputeService.fetch
   */
  fetch(arg0: ComputeFilterDto): RestResponse<SharedPagedResponse<ComputeDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`computes`, data: arg0 });
  }

  /**
   * Get compute by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /computes/{id}
   * Java method: com.neovia.equadvice.data.service.ComputeService.get
   */
  get(id: string): RestResponse<ComputeDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`computes/${id}` });
  }

  /**
   * Save compute (temp) result to calculated results
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /computes/{id}/save
   * Java method: com.neovia.equadvice.data.service.ComputeService.saveSave
   */
  saveSave(id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`computes/${id}/save` });
  }

  /**
   * Force status to valid
   * Response code 200 - No error (watch out the status can be not changed with success)
   * Response code 500 - Error
   * HTTP POST /computes/{id}/force-calc-status
   * Java method: com.neovia.equadvice.data.service.ComputeService.forceCalcStatus
   */
  forceCalcStatus(id: string): RestResponse<ComputeDto> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`computes/${id}/force-calc-status` });
  }
}


@Injectable()
export class DataSampleTempCalculationServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Performs the saving of temporary calculation, and generates the bulletin (updates sample's reference if necessary)
   * HTTP PATCH /sample-temporary-calculation/{tempCalcId}/save-and-generate-bulletin?sampleId?{sampleId}
   * @param tempCalculationId ID for temp calculation
   * @param sampleId          the ID of the sample
   */
  saveTemporaryCalculationAndGenerateBulletin(tempCalculationId: string, sampleId: string): Observable<void> {
    let templates: string[] = [];
    let url = null;
    let index = 0;
    templates[index++] = `sample-temporary-calculation/`;
    templates[index] = `/save-and-generate-bulletin`;
    templates[index++] += `?sampleId=`;
    // Because of the implementation of uriEncoding...
    templates[index] = '';
    url = uriEncoding(templates as any, tempCalculationId, sampleId);
    return this.httpClient.request({ method: 'PATCH', url: url });
  }
}


@Injectable()
export class DataSampleBulletinServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Send the bulletin link to the sample by mail
   * HTTP POST samples/${sampleId}/bulletin/mail
   * @param tempCalculationId ID for temp calculation
   * @param sampleId          the ID of the sample
   */
  sendBulletinByMail(sampleId: string): Observable<void> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`samples/${sampleId}/bulletin/mail` });
  }
}

@Injectable()
export class DomainRightNutrientServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Export nutrient rights by entity
   * Response code 200 - excel file
   * Response code 404 - Not found
   * HTTP GET /rights/nutrients
   * Java method: com.neovia.equadvice.data.service.DomainRightNutrientService.export
   */
  export(arg0: DomainRightNutrientFilterDto): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`rights/nutrients`, data: arg0 });
  }

  /**
   * Get filtered & paged nutrient rights by entity
   * Response code 206 - Partial ranged nutrient rights by entity
   * Response code 404 - Not found
   * HTTP GET /rights/nutrients
   * Java method: com.neovia.equadvice.data.service.DomainRightNutrientService.fetch
   */
  fetch(arg0: DomainRightNutrientFilterDto): RestResponse<SharedPagedResponse<DomainRightNutrientDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`rights/nutrients`, data: arg0 });
  }

  /**
   * Patch nutrient right for an entity
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP PATCH /rights/nutrients
   * Java method: com.neovia.equadvice.data.service.DomainRightNutrientService.patch
   */
  patch(arg0: DomainRightPatchDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`rights/nutrients`, data: arg0 });
  }
}

@Injectable()
export class DomainRightPredictionModelServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Export prediction model rights by entity
   * Response code 200 - excel file
   * Response code 404 - Not found
   * HTTP GET /rights/prediction_models
   * Java method: com.neovia.equadvice.data.service.DomainRightPredictionModelService.export
   */
  export(arg0: DomainRightPredictionModelFilterDto): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`rights/prediction_models`, data: arg0 });
  }

  /**
   * Get filtered & paged prediction model rights by entity
   * Response code 206 - Partial ranged prediction model rights by entity
   * Response code 404 - Not found
   * HTTP GET /rights/prediction_models
   * Java method: com.neovia.equadvice.data.service.DomainRightPredictionModelService.fetch
   */
  fetch(arg0: DomainRightPredictionModelFilterDto): RestResponse<SharedPagedResponse<DomainRightDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`rights/prediction_models`, data: arg0 });
  }

  /**
   * Patch prediction model right for an entity
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP PATCH /rights/prediction_models
   * Java method: com.neovia.equadvice.data.service.DomainRightPredictionModelService.patch
   */
  patch(arg0: DomainRightPatchDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`rights/prediction_models`, data: arg0 });
  }
}

@Injectable()
export class DomainRightReferenceServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Export reference rights by entity
   * Response code 200 - excel file
   * Response code 404 - Not found
   * HTTP GET /rights/references
   * Java method: com.neovia.equadvice.data.service.DomainRightReferenceService.export
   */
  export(arg0: DomainRightReferenceFilterDto): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`rights/references`, data: arg0 });
  }

  /**
   * Get filtered & paged reference rights by entity
   * Response code 206 - Partial ranged reference rights by entity
   * Response code 404 - Not found
   * HTTP GET /rights/references
   * Java method: com.neovia.equadvice.data.service.DomainRightReferenceService.fetch
   */
  fetch(arg0: DomainRightReferenceFilterDto): RestResponse<SharedPagedResponse<DomainRightReferenceDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`rights/references`, data: arg0 });
  }

  /**
   * Patch reference right for an entity
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP PATCH /rights/references
   * Java method: com.neovia.equadvice.data.service.DomainRightReferenceService.patch
   */
  patch(arg0: DomainRightPatchDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`rights/references`, data: arg0 });
  }
}

@Injectable()
export class EntityServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create nutrient class or meta class
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /entities/{entityCode}/classes
   * Java method: com.neovia.equadvice.data.service.SubClassService.classesCreate
   */
  classesCreate(entityCode: string, arg0: ClassDto): RestResponse<ClassDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities/${entityCode}/classes`, data: arg0 });
  }

  /**
   * Delete class
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP DELETE /entities/{entityCode}/classes/{id}
   * Java method: com.neovia.equadvice.data.service.SubClassService.classesDelete
   */
  classesDelete(entityCode: string, id: string): RestResponse<any> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`entities/${entityCode}/classes/${id}` });
  }

  /**
   * Delete mzr  class
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP DELETE /entities/{entityCode}/classes/meta/{id}
   * Java method: com.neovia.equadvice.data.service.SubClassService.classesmetaDeleteMetaClass
   */
  classesmetaDeleteMetaClass(entityCode: string, id: string): RestResponse<any> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`entities/${entityCode}/classes/meta/${id}` });
  }

  /**
   * Get all classes (meta + class)
   * Response code 200 - Partial ranged classes
   * Response code 404 - Not found
   * HTTP GET /entities/{entityCode}/classes
   * Java method: com.neovia.equadvice.data.service.SubClassService.classesFetch
   */
  classesFetch(entityCode: string, arg0: ClassFilterDto): RestResponse<SharedPagedResponse<ClassDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/classes`, data: arg0 });
  }

  /**
   * Get class or meta by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /entities/{entityCode}/classes/{id}
   * Java method: com.neovia.equadvice.data.service.SubClassService.classesGet
   */
  classesGet(entityCode: string, id: string): RestResponse<ClassDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/classes/${id}` });
  }

  /**
   * Patch class and nutrients order
   * Response code 204 - Modified
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP PATCH /entities/{entityCode}/classes/order
   * Java method: com.neovia.equadvice.data.service.SubClassService.classesorderPatch
   */
  classesorderPatch(entityCode: string, arg0: PatchClassesDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`entities/${entityCode}/classes/order`, data: arg0 });
  }

  /**
   * Update class or meta class
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PUT /entities/{entityCode}/classes
   * Java method: com.neovia.equadvice.data.service.SubClassService.classesPut
   */
  classesPut(entityCode: string, arg0: ClassDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`entities/${entityCode}/classes`, data: arg0 });
  }

  /**
   * Delete entity rights
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /entities/{entityCode}/rights
   * Java method: com.neovia.equadvice.data.service.EntityService.rightsDeleteEntityRights
   */
  rightsDeleteEntityRights(entityCode: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`entities/${entityCode}/rights` });
  }

  /**
   * Get all references
   * Response code 200 - Partial ranged references
   * Response code 404 - Not found
   * HTTP GET /entities/{entityCode}/prediction_models
   * Java method: com.neovia.equadvice.data.service.SubPredictionModelService.predictionModelsFetch
   */
  predictionModelsFetch(entityCode: string, arg0: PredictionModelFilterDto): RestResponse<SharedPagedResponse<PredictionModelDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/prediction_models`, data: arg0 });
  }

  /**
   * Cancel a calculate batch
   * Response code 204 - Cancel
   * Response code 500 - Error
   * HTTP DELETE /entities/{entityCode}/raw_materials/calculate-batch/{id}/cancel
   * Java method: com.neovia.equadvice.data.service.SubRawMaterialCalculateBatchService.rawMaterialscalculateBatchCancelCancel
   */
  rawMaterialscalculateBatchCancelCancel(entityCode: string, id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`entities/${entityCode}/raw_materials/calculate-batch/${id}/cancel` });
  }

  /**
   * Create calculate batch
   * Response code 200 - OK
   * Response code 500 - Error
   * HTTP POST /entities/{entityCode}/raw_materials/calculate-batch/{type}
   * Java method: com.neovia.equadvice.data.service.SubRawMaterialCalculateBatchService.rawMaterialscalculateBatchCreate
   */
  rawMaterialscalculateBatchCreate(entityCode: string, type: string, arg1: string[]): RestResponse<string> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities/${entityCode}/raw_materials/calculate-batch/${type}`, data: arg1 });
  }

  /**
   * Delete a calculate batch
   * Response code 204 - Cancel
   * Response code 500 - Error
   * HTTP DELETE /entities/{entityCode}/raw_materials/calculate-batch/{id}
   * Java method: com.neovia.equadvice.data.service.SubRawMaterialCalculateBatchService.rawMaterialscalculateBatchDelete
   */
  rawMaterialscalculateBatchDelete(entityCode: string, id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`entities/${entityCode}/raw_materials/calculate-batch/${id}` });
  }

  /**
   * Get calculate batchs of user
   * Response code 200 - OK
   * Response code 500 - Error
   * HTTP GET /entities/{entityCode}/raw_materials/calculate-batch/{type}
   * Java method: com.neovia.equadvice.data.service.SubRawMaterialCalculateBatchService.rawMaterialscalculateBatchGetJobs
   */
  rawMaterialscalculateBatchGetJobs(entityCode: string, type: string): RestResponse<JobDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/raw_materials/calculate-batch/${type}` });
  }

  /**
   * Get calculate batch result
   * Response code 200 - OK
   * Response code 303 - See status
   * Response code 500 - Error
   * HTTP GET /entities/{entityCode}/raw_materials/calculate-batch/{id}/result
   * Java method: com.neovia.equadvice.data.service.SubRawMaterialCalculateBatchService.rawMaterialscalculateBatchResultGetResult
   */
  rawMaterialscalculateBatchResultGetResult(entityCode: string, id: string): RestResponse<any> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/raw_materials/calculate-batch/${id}/result` });
  }

  /**
   * Get calculate batch status
   * Response code 200 - OK
   * Response code 303 - See result
   * Response code 500 - Error
   * HTTP GET /entities/{entityCode}/raw_materials/calculate-batch/{id}/status
   * Java method: com.neovia.equadvice.data.service.SubRawMaterialCalculateBatchService.rawMaterialscalculateBatchStatusGetStatus
   */
  rawMaterialscalculateBatchStatusGetStatus(entityCode: string, id: string): RestResponse<JobStatusInfo> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/raw_materials/calculate-batch/${id}/status` });
  }

  /**
   * Export rawmaterials
   * Response code 200 - OK
   * Response code 500 - Error
   * HTTP POST /entities/{entityCode}/raw_materials/export
   * Java method: com.neovia.equadvice.data.service.SubRawMaterialExportService.rawMaterialsexportExport
   */
  rawMaterialsexportExport(entityCode: string, arg1: EntityRawMaterialsDto[], queryParams?: { matrixCode?: string; }): RestResponse<ExportResponseDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities/${entityCode}/raw_materials/export`, queryParams: queryParams, data: arg1 });
  }

  /**
   * Export of rawmaterials finished
   * Response code 204 - OK
   * Response code 500 - Error
   * HTTP POST /entities/{entityCode}/raw_materials/export/finished
   * Java method: com.neovia.equadvice.data.service.SubRawMaterialExportService.rawMaterialsexportfinishedExportFinished
   */
  rawMaterialsexportfinishedExportFinished(entityCode: string, arg1: EntityRawMaterialsDto[], queryParams?: { date?: any; }): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities/${entityCode}/raw_materials/export/finished`, queryParams: queryParams, data: arg1 });
  }

  /**
   * Export rawmaterials notification
   * Response code 200 - OK
   * Response code 500 - Error
   * HTTP POST /entities/{entityCode}/raw_materials/export/notification
   * Java method: com.neovia.equadvice.data.service.SubRawMaterialExportService.rawMaterialsexportnotificationExportNotification
   */
  rawMaterialsexportnotificationExportNotification(entityCode: string, arg1: ExportRequestDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities/${entityCode}/raw_materials/export/notification`, data: arg1 });
  }

  rawMaterialsexportnotificationExportMultiFormatNotification(entityCode: string, arg1: ExportMultiFormatRequestDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities/${entityCode}/raw_materials/export/notificationMultiFormat`, data: arg1 });
  }

  /**
   * Get result
   * Response code 200 - results
   * Response code 404 - Raw material Not found
   * HTTP GET /entities/{entityCode}/raw_materials/{id}/results
   * Java method: com.neovia.equadvice.data.service.SubResultService.fetchForFeed
   */
  rawMaterialsResultsFetch(entityCode: string, id: string, arg0: ResultFilterDto): RestResponse<ResultDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/raw_materials/${id}/results`, data: arg0 });
  }

  /**
   * Get all references
   * Response code 200 - Partial ranged references
   * Response code 404 - Not found
   * HTTP GET /entities/{entityCode}/references
   * Java method: com.neovia.equadvice.data.service.SubReferenceService.referencesFetch
   */
  referencesFetch(entityCode: string, arg0: ReferenceFilterDto): RestResponse<SharedPagedResponse<ReferenceDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/references`, data: arg0 });
  }

  /**
   * Get reference by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /entities/{entityCode}/references/{id}
   * Java method: com.neovia.equadvice.data.service.SubReferenceService.referencesGet
   */
  referencesGet(entityCode: string, id: string, queryParams?: { translated?: boolean; }): RestResponse<ReferenceDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/references/${id}`, queryParams: queryParams });
  }
}

@Injectable()
export class RawMaterialService {
  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Get filtered & paged rawmaterials
   * Response code 206 - Partial ranged rawmaterials
   * Response code 404 - Not found
   * HTTP GET /entities/{entityCode}/raw_materials
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.rawMaterialsFetch
   */
  fetch(entityCode: string, arg0: RawMaterialFilterDto): RestResponse<SharedPagedResponse<RawMaterialDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/raw_materials`, data: arg0 });
  }

  /**
   * Get rawmaterial by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /entities/{entityCode}/raw_materials/{id}
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.rawMaterialsGet
   */
  get(entityCode: string, id: string): RestResponse<RawMaterialDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/raw_materials/${id}` });
  }

  /**
   * HTTP GET /entities/{entityCode}/raw_materials/{id}/nutrients
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.rawMaterialsNutrientsGetAllNutrients
   */
  getAllRawMatNutrients(entityCode: string, id: string, referenceId?: string): RestResponse<RawMaterialNutrientDto[]> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`entities/${entityCode}/raw_materials/${id}/nutrients`,
      queryParams: {
        referenceId: referenceId??''
      }
    });
  }

  /**
   * Get all nutrients for all raw materials
   * HTTP POST /entities/{entityCode}/raw_materials/nutrients
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.rawMaterialsNutrientsGetAllNutrients
   */
  rawMaterialsNutrientsGetAllNutrientsForAllRawMat(entityCode: string, arg0: RawMaterialFilterDto): RestResponse<[string, RawMaterialNutrientDto[]]> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities/${entityCode}/raw_materials/nutrients`, data: arg0 });
  }

  /**
   * HTTP GET /entities/{entityCode}/raw_materials/{id}/nutrient-classes
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.rawMaterialsNutrientClassesGetNutrientClasses
   */
  getNutrientClasses(entityCode: string, id: string, queryParams?: { translated?: boolean; }): RestResponse<ClassNutrientDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/raw_materials/${id}/nutrient-classes`, queryParams: queryParams });
  }

  /**
   * HTTP GET /entities/{entityCode}/raw_materials/{id}/report
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.rawMaterialsReportGetReport
   */
  getReport(entityCode: string, id: string, arg1: ReportDto): RestResponse<any> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/raw_materials/${id}/report`, data: arg1 });
  }

  /**
   * Modify RawMaterials
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PATCH /entities/{entityCode}/raw_materials/patch
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.rawMaterialsPatch
   */
  patch(entityCode: string, arg0: RawMaterialPatchDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`entities/${entityCode}/raw_materials/patch`, data: arg0 });
  }

  /**
   * Modify RawMaterial
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PATCH /entities/{entityCode}/raw_materials/locked-by-me
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.rawMaterialslockedByMePatchLockedByMe
   */
  lockedByMePatchLockedByMe(entityCode: string, arg0: RawMaterialPatchDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`entities/${entityCode}/raw_materials/locked-by-me`, data: arg0 });
  }

  /**
   * Modify rawmaterial
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PUT /entities/{entityCode}/raw_materials/{id}
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.put
   */
  put(entityCode: string, id: string, arg0: RawMaterialDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`entities/${entityCode}/raw_materials/${id}`, data: arg0 });
  }



  /**
   * Create rawmaterial
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /entities/{entityCode}/raw_materials
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.rawMaterialsCreate
   */
  create(entityCode: string, arg0: RawMaterialDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities/${entityCode}/raw_materials`, data: arg0 });
  }

  /**
   * Change rawmaterial status
   * Response code 201 - Status changed
   * Response code 500 - Error
   * HTTP POST /entities/{entityCode}/raw_materials
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.rawMaterialsChangeStatus
   */
  changeStatus(entityCode: string, arg0: RawMaterialDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities/${entityCode}/raw_materials/changeStatus`, data: arg0 });
  }

  /**
   * Delete rawmaterial
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /entities/{entityCode}/raw_materials/{id}
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.delete
   */
  delete(entityCode: string, id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`entities/${entityCode}/raw_materials/${id}` });
  }

  /**
   * Delete rawmaterials by activity And entity
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /entities/{entityCode}/raw_materials
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.rawMaterialsDeleteActivityCodeAndEntityCode
   */
  deleteActivityCodeAndEntityCode(entityCode: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`entities/${entityCode}/raw_materials` });
  }

  /**
   * Duplicate rawmaterial
   * Response code 200 - Duplicate
   * Response code 500 - Error
   * HTTP PUT /entities/{entityCode}/raw_materials/duplicate/{id}
   * Java method: com.neovia.equadvice.data.service.RawMaterialService.duplicate
   */
  duplicate(entityCode: string, idRawMatToDuplicate: string, arg0: RawMaterialDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities/${entityCode}/raw_materials/duplicate/${idRawMatToDuplicate}`, data: arg0 });
  }

  /**
   * Save multiple rawmaterial batch
   * Response code 200 - OK
   * Response code 500 - Error
   * HTTP POST /entities/{entityCode}/raw_materials/multi-save-batch
   * Java method: com.neovia.equadvice.data.service.SubRawMaterialMultiSaveService.create
   */
  rawMaterialsMultipleSaveBatchCreate(entityCode: string, arg0: RawMaterialSaveDto): RestResponse<string> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities/${entityCode}/raw_materials/multi-save-batch`, data: arg0});
  }

  /**
   * Get save multiple rawmaterial batch result
   * Response code 200 - OK
   * Response code 303 - See status
   * Response code 500 - Error
   * HTTP GET /entities/{entityCode}/raw_materials/multi-save-batch/{id}/result
   * Java method: com.neovia.equadvice.data.service.SubRawMaterialMultiSaveService.getResult
   */
  rawMaterialsMultipleSaveBatchResultGetResult(entityCode: string, id: string): RestResponse<any> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/raw_materials/multi-save-batch/${id}/result` });
  }

  /**
   * Get save multiple rawmaterial batch status
   * Response code 200 - OK
   * Response code 303 - See result
   * Response code 500 - Error
   * HTTP GET /entities/{entityCode}/raw_materials/multi-save-batch/{id}/status
   * Java method: com.neovia.equadvice.data.service.SubRawMaterialMultiSaveService.getStatus
   */
  rawMaterialsMultipleSaveBatchStatusGetStatus(entityCode: string, id: string): RestResponse<JobStatusInfo> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/raw_materials/multi-save-batch/${id}/status` });
  }

}

@Injectable()
export class LevelServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create level
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /levels
   * Java method: com.neovia.equadvice.data.service.LevelService.create
   */
  create(arg0: LevelDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`levels`, data: arg0 });
  }

  /**
   * Delete level
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /levels/{id}
   * Java method: com.neovia.equadvice.data.service.LevelService.delete
   */
  delete(id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`levels/${id}` });
  }

  /**
   * Get filtered & paged level translates
   * Response code 206 - Partial ranged level translates
   * Response code 404 - Not found
   * HTTP GET /levels/{levelId}/translates
   * Java method: com.neovia.equadvice.data.service.SubLevelDomainTranslateService.translatesFetch
   */
  translatesFetch(levelId: string): RestResponse<DomainTranslateDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`levels/${levelId}/translates` });
  }

  /**
   * Patch level translate
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP PATCH /levels/{levelId}/translates
   * Java method: com.neovia.equadvice.data.service.SubLevelDomainTranslateService.translatesPatch
   */
  translatesPatch(levelId: string, arg0: DomainTranslateDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`levels/${levelId}/translates`, data: arg0 });
  }

  /**
   * Get all levels
   * Response code 200 - Partial ranged level
   * Response code 404 - Not found
   * HTTP GET /levels
   * Java method: com.neovia.equadvice.data.service.LevelService.fetch
   */
  fetch(arg0: LevelFilterDto): RestResponse<SharedPagedResponse<LevelDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`levels`, data: arg0 });
  }

  /**
   * Get level by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /levels/{id}
   * Java method: com.neovia.equadvice.data.service.LevelService.get
   */
  get(id: string, queryParams?: { translated?: boolean; }): RestResponse<LevelDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`levels/${id}`, queryParams: queryParams });
  }

  /**
   * Update level
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PUT /levels
   * Java method: com.neovia.equadvice.data.service.LevelService.put
   */
  put(arg0: LevelDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`levels`, data: arg0 });
  }
}

@Injectable()
export class NutrientServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create nutrient
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /nutrients
   * Java method: com.neovia.equadvice.data.service.NutrientService.create
   */
  create(arg0: NutrientDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`nutrients`, data: arg0 });
  }

  /**
   * Delete nutrient
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /nutrients/{id}
   * Java method: com.neovia.equadvice.data.service.NutrientService.delete
   */
  delete(id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`nutrients/${id}` });
  }

  /**
   * Get filtered & paged nutrient translates
   * Response code 206 - Partial ranged nutrient translates
   * Response code 404 - Not found
   * HTTP GET /nutrients/{nutrientId}/translates
   * Java method: com.neovia.equadvice.data.service.SubNutrientDomainTranslateService.translatesFetch
   */
  translatesFetch(nutrientId: string): RestResponse<DomainTranslateDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`nutrients/${nutrientId}/translates` });
  }

  /**
   * Patch nutrient translate
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP PATCH /nutrients/{nutrientId}/translates
   * Java method: com.neovia.equadvice.data.service.SubNutrientDomainTranslateService.translatesPatch
   */
  translatesPatch(nutrientId: string, arg0: DomainTranslateDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`nutrients/${nutrientId}/translates`, data: arg0 });
  }

  /**
   * Get filtered & paged nutrients
   * Response code 206 - Partial ranged nutrients
   * Response code 404 - Not found
   * HTTP GET /nutrients
   * Java method: com.neovia.equadvice.data.service.NutrientService.fetch
   */
  fetch(arg0: NutrientFilterDto): RestResponse<SharedPagedResponse<NutrientDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`nutrients`, data: arg0 });
  }

  /**
   * Get nutrient by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /nutrients/{id}
   * Java method: com.neovia.equadvice.data.service.NutrientService.get
   */
  get(id: string, queryParams?: { translated?: boolean; }): RestResponse<NutrientDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`nutrients/${id}`, queryParams: queryParams });
  }

  /**
   * Get nutrient technical doc
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /nutrients/technical-doc
   * Java method: com.neovia.equadvice.data.service.NutrientService.getTechnicalDoc
   */
  getTechnicalDoc(arg0: AsyncResponse, queryParams?: { filename?: string; }): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`nutrients/technical-doc`, queryParams: queryParams, data: arg0 });
  }

  /**
   * Update nutrient
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PUT /nutrients
   * Java method: com.neovia.equadvice.data.service.NutrientService.put
   */
  put(arg0: NutrientDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`nutrients`, data: arg0 });
  }
}

@Injectable()
export class PredictionModelServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create prediction model
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /prediction_models
   * Java method: com.neovia.equadvice.data.service.PredictionModelService.create
   */
  create(arg0: PredictionModelDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`prediction_models`, data: arg0 });
  }

  /**
   * Delete prediction model
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /prediction_models/{id}
   * Java method: com.neovia.equadvice.data.service.PredictionModelService.delete
   */
  delete(id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`prediction_models/${id}` });
  }

  /**
   * Get filtered & paged prediction_model translates
   * Response code 206 - Partial ranged prediction model translates
   * Response code 404 - Not found
   * HTTP GET /prediction_models/{predictionModelId}/translates
   * Java method: com.neovia.equadvice.data.service.SubPredictionModelDomainTranslateService.translatesFetch
   */
  translatesFetch(predictionModelId: string): RestResponse<DomainTranslateDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`prediction_models/${predictionModelId}/translates` });
  }

  /**
   * Patch prediction_model translate
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP PATCH /prediction_models/{predictionModelId}/translates
   * Java method: com.neovia.equadvice.data.service.SubPredictionModelDomainTranslateService.translatesPatch
   */
  translatesPatch(predictionModelId: string, arg0: DomainTranslateDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`prediction_models/${predictionModelId}/translates`, data: arg0 });
  }

  /**
   * Get filtered & paged prediction models
   * Response code 206 - Partial ranged prediction models
   * Response code 404 - Not found
   * HTTP GET /prediction_models
   * Java method: com.neovia.equadvice.data.service.PredictionModelService.fetch
   */
  fetch(arg0: PredictionModelFilterDto): RestResponse<SharedPagedResponse<PredictionModelDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`prediction_models`, data: arg0 });
  }

  /**
   * Get prediction model by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /prediction_models/{id}
   * Java method: com.neovia.equadvice.data.service.PredictionModelService.get
   */
  get(id: string, queryParams?: { translated?: boolean; }): RestResponse<PredictionModelDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`prediction_models/${id}`, queryParams: queryParams });
  }

  /**
   * Get prediction model technical doc
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /prediction_models/technical-doc
   * Java method: com.neovia.equadvice.data.service.PredictionModelService.getTechnicalDoc
   */
  getTechnicalDoc(arg0: AsyncResponse, queryParams?: { filename?: string; }): RestResponse<void> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`prediction_models/technical-doc`, queryParams: queryParams, data: arg0 });
  }

  /**
   * Create optional nutrient value
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /prediction_models/{id}/optional_nutrients/{nutrientId}
   * Java method: com.neovia.equadvice.data.service.OptionalNutrientService.optionalNutrientsCreate
   */
  optionalNutrientsCreate(id: string, nutrientId: string): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`prediction_models/${id}/optional_nutrients/${nutrientId}` });
  }

  /**
   * Delete optional nutrient
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /prediction_models/{id}/optional_nutrients/{nutrientId}
   * Java method: com.neovia.equadvice.data.service.OptionalNutrientService.optionalNutrientsDelete
   */
  optionalNutrientsDelete(id: string, nutrientId: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`prediction_models/${id}/optional_nutrients/${nutrientId}` });
  }

  /**
   * Get filtered & paged optionalNutrient
   * Response code 206 - Partial ranged optionalNutrients
   * Response code 404 - Not found
   * HTTP GET /prediction_models/{id}/optional_nutrients
   * Java method: com.neovia.equadvice.data.service.OptionalNutrientService.optionalNutrientsFetch
   */
  optionalNutrientsFetch(id: string, arg0: OptionalNutrientFilterDto): RestResponse<SharedPagedResponse<OptionalNutrientDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`prediction_models/${id}/optional_nutrients`, data: arg0 });
  }

  /**
   * Create facultative nutrient value
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /prediction_models/{id}/facultative_nutrients/{nutrientId}
   * Java method: com.neovia.equadvice.data.service.FacultativeNutrientService.facultativeNutrientsCreate
   */
  facultativeNutrientsCreate(id: string, nutrientId: string): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`prediction_models/${id}/facultative_nutrients/${nutrientId}` });
  }

  /**
   * Delete facultative nutrient
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /prediction_models/{id}/facultative_nutrients/{nutrientId}
   * Java method: com.neovia.equadvice.data.service.FacultativeNutrientService.facultativeNutrientsDelete
   */
  facultativeNutrientsDelete(id: string, nutrientId: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`prediction_models/${id}/facultative_nutrients/${nutrientId}` });
  }

  /**
   * Get filtered & paged facultativeNutrient
   * Response code 206 - Partial ranged facultativeNutrients
   * Response code 404 - Not found
   * HTTP GET /prediction_models/{id}/facultative_nutrients
   * Java method: com.neovia.equadvice.data.service.FacultativeNutrientService.facultativeNutrientsFetch
   */
  facultativeNutrientsFetch(id: string, arg0: FacultativeNutrientFilterDto): RestResponse<SharedPagedResponse<FacultativeNutrientDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`prediction_models/${id}/facultative_nutrients`, data: arg0 });
  }

  /**
   * Update prediction model
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PUT /prediction_models
   * Java method: com.neovia.equadvice.data.service.PredictionModelService.put
   */
  put(arg0: PredictionModelDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`prediction_models`, data: arg0 });
  }

  /**
   * Duplicate prediction model
   * Response code 201 - Duplicated
   * Response code 500 - Error
   */
  duplicated(id: string): RestResponse<any> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`prediction_models/${id}/duplicated` });
  }

  /**
   * Create variable value
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /prediction_models/{id}/variable_values
   * Java method: com.neovia.equadvice.data.service.SubVariableValueService.variableValuesCreate
   */
  variableValuesCreate(id: string, arg0: VariableValueDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`prediction_models/${id}/variable_values`, data: arg0 });
  }

  /**
   * Delete variable value
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /prediction_models/{id}/variable_values/{variableCode}
   * Java method: com.neovia.equadvice.data.service.SubVariableValueService.variableValuesDelete
   */
  variableValuesDelete(id: string, variableCode: string, queryParams?: { value?: string; }): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`prediction_models/${id}/variable_values/${variableCode}`, queryParams: queryParams });
  }

  /**
   * Get filtered & paged variableValues
   * Response code 206 - Partial ranged variableValues
   * Response code 404 - Not found
   * HTTP GET /prediction_models/{id}/variable_values
   * Java method: com.neovia.equadvice.data.service.SubVariableValueService.variableValuesFetch
   */
  variableValuesFetch(id: string, arg0: VariableValueFilterDto): RestResponse<SharedPagedResponse<VariableValueDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`prediction_models/${id}/variable_values`, data: arg0 });
  }

  /**
   * Get variableValue by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /prediction_models/{id}/variable_values/{variableCode}
   * Java method: com.neovia.equadvice.data.service.SubVariableValueService.variableValuesGet
   */
  variableValuesGet(id: string, variableCode: string): RestResponse<VariableValueDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`prediction_models/${id}/variable_values/${variableCode}` });
  }

  /**
   * Modify variable value
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PATCH /prediction_models/{id}/variable_values/{variableCode}
   * Java method: com.neovia.equadvice.data.service.SubVariableValueService.variableValuesPatch
   */
  variableValuesPatch(id: string, variableCode: string, arg1: PatchDto<string>[]): RestResponse<VariableValueDto> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`prediction_models/${id}/variable_values/${variableCode}`, data: arg1 });
  }
}

@Injectable()
export class ReferenceServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create reference
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /references
   * Java method: com.neovia.equadvice.data.service.ReferenceService.create
   */
  create(arg0: ReferenceDto): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`references`, data: arg0 });
  }

  /**
   * Delete reference
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /references/{id}
   * Java method: com.neovia.equadvice.data.service.ReferenceService.delete
   */
  delete(id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`references/${id}` });
  }

  /**
   * Get filtered & paged reference translates
   * Response code 206 - Partial ranged reference translates
   * Response code 404 - Not found
   * HTTP GET /references/{referenceId}/translates
   * Java method: com.neovia.equadvice.data.service.SubReferenceDomainTranslateService.translatesFetch
   */
  translatesFetch(referenceId: string): RestResponse<DomainTranslateDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`references/${referenceId}/translates` });
  }

  /**
   * Patch reference translate
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP PATCH /references/{referenceId}/translates
   * Java method: com.neovia.equadvice.data.service.SubReferenceDomainTranslateService.translatesPatch
   */
  translatesPatch(referenceId: string, arg0: DomainTranslateDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`references/${referenceId}/translates`, data: arg0 });
  }

  /**
   * Get all references
   * Response code 200 - Partial ranged references
   * Response code 404 - Not found
   * HTTP GET /references
   * Java method: com.neovia.equadvice.data.service.ReferenceService.fetch
   */
  fetch(arg0: ReferenceFilterDto): RestResponse<SharedPagedResponse<ReferenceDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`references`, data: arg0 });
  }

  /**
   * Get reference by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /references/{id}
   * Java method: com.neovia.equadvice.data.service.ReferenceService.get
   */
  get(id: string, queryParams?: { translated?: boolean; }): RestResponse<ReferenceDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`references/${id}`, queryParams: queryParams });
  }

  /**
   * Get reference by code
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /references/code/{code}
   * Java method: com.neovia.equadvice.data.service.ReferenceService.getByCodeApiRoute
   */
  getByCode(code: string, queryParams?: { translated?: boolean; }): RestResponse<ReferenceDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`references/code/${code}`, queryParams: queryParams });
  }

  /**
   * Update reference
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PUT /references
   * Java method: com.neovia.equadvice.data.service.ReferenceService.put
   */
  put(arg0: ReferenceDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`references`, data: arg0 });
  }

  duplicated(id: string): RestResponse<any> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`references/${id}/duplicated` });
  }

  /**
   * Get filtered & paged reference values
   * Response code 206 - Partial ranged referenceValues
   * Response code 404 - Not found
   * HTTP GET /references/{id}/reference_values
   * Java method: com.neovia.equadvice.data.service.ReferenceValueService.referenceValuesFetch
   */
  referenceValuesFetch(id: string, arg0: ReferenceValueFilterDto): RestResponse<SharedPagedResponse<ReferenceValueDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`references/${id}/reference_values`, data: arg0 });
  }

  /**
   * Update refrence value
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PUT /references/{id}/reference_values
   * Java method: com.neovia.equadvice.data.service.ReferenceValueService.referenceValuesPut
   */
  referenceValuesPut(id: string, arg0: ReferenceValueDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`references/${id}/reference_values`, data: arg0 });
  }

  /**
   * Calculate the default ceiling value
   * @param refVal the ReferenceValue from which we want the ceiling value
   * @returns the ceiling value of the ReferenceValue
   */
  static getDefaultCeilValueFromRefVal(refVal: ReferenceValueDto): number {
    const minValue = this.getLimitValueToHave(refVal.minVal, refVal.minDefault) ;
    const maxValue = this.getLimitValueToHave(refVal.maxVal, refVal.maxDefault) ;
    return FloorCeilCalculationService.getDefaultCeilVal(minValue, maxValue) ;
  }

  /**
   * Calculate the default floor value
   * @param refVal the ReferenceValue from which we want the default floor value
   * @returns the default floor value of the the ReferenceValue
   */
  static getDefaultFloorValueFromRefVal(refVal: ReferenceValueDto): number {
    const minValue = this.getLimitValueToHave(refVal.minVal, refVal.minDefault) ;
    const maxValue = this.getLimitValueToHave(refVal.maxVal, refVal.maxDefault) ;
    return FloorCeilCalculationService.getDefaultFloorVal(minValue, maxValue) ;
  }

  /**
   * Return the limit value that will be used in back
   * @param inputLimitValue the limit value setted by the user
   * @param defaultLimitValue the default limit from the property of nutrient
   * @returns the corresponding limit value
   */
  private static getLimitValueToHave(inputLimitValue: number|string, defaultLimitValue: number): number {
    return (inputLimitValue || inputLimitValue === 0) ? +inputLimitValue : defaultLimitValue ;
  }
}

@Injectable()
export class RootVariableValueServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Modify variable code
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP POST /variable_values
   * Java method: com.neovia.equadvice.data.service.RootVariableValueService.patch
   */
  patch(queryParams?: { oldVariableCode?: string; newVariableCode?: string; }): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`variable_values`, queryParams: queryParams });
  }
}

@Injectable()
export class SubClassNutrientTranslateServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Get filtered & paged class nutrient translates
   * Response code 206 - Partial ranged class nutrient translates
   * Response code 404 - Not found
   * HTTP GET /class_nutrient_translates
   * Java method: com.neovia.equadvice.data.service.SubClassNutrientTranslateService.fetch
   */
  fetch(arg0: TranslateClassNutrientFilterDto): RestResponse<SharedPagedResponse<TranslateClassNutrientDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`class_nutrient_translates`, data: arg0 });
  }

  /**
   * Patch class nutrient translate
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP PATCH /class_nutrient_translates
   * Java method: com.neovia.equadvice.data.service.SubClassNutrientTranslateService.patch
   */
  patch(arg0: TranslateDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`class_nutrient_translates`, data: arg0 });
  }
}

@Injectable()
export class SubClassServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create nutrient class or meta class
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /classes
   * Java method: com.neovia.equadvice.data.service.SubClassService.create
   */
  create(arg0: ClassDto): RestResponse<ClassDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`classes`, data: arg0 });
  }

  /**
   * Delete class
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP DELETE /classes/{id}
   * Java method: com.neovia.equadvice.data.service.SubClassService.delete
   */
  delete(id: string): RestResponse<any> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`classes/${id}` });
  }

  /**
   * Delete mzr  class
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP DELETE /classes/meta/{id}
   * Java method: com.neovia.equadvice.data.service.SubClassService.deleteMetaClass
   */
  deleteMetaClass(id: string): RestResponse<any> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`classes/meta/${id}` });
  }

  /**
   * Get all classes (meta + class)
   * Response code 200 - Partial ranged classes
   * Response code 404 - Not found
   * HTTP GET /classes
   * Java method: com.neovia.equadvice.data.service.SubClassService.fetch
   */
  fetch(arg0: ClassFilterDto): RestResponse<SharedPagedResponse<ClassDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`classes`, data: arg0 });
  }

  /**
   * Get class or meta by id
   * Response code 200 - Obtained
   * Response code 404 - Not found
   * HTTP GET /classes/{id}
   * Java method: com.neovia.equadvice.data.service.SubClassService.get
   */
  get(id: string): RestResponse<ClassDto> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`classes/${id}` });
  }

  /**
   * Patch class and nutrients order
   * Response code 204 - Modified
   * Response code 404 - Not Found
   * Response code 500 - Error
   * HTTP PATCH /classes/order
   * Java method: com.neovia.equadvice.data.service.SubClassService.patch
   */
  patch(arg0: PatchClassesDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`classes/order`, data: arg0 });
  }

  /**
   * Update class or meta class
   * Response code 200 - Modify
   * Response code 500 - Error
   * HTTP PUT /classes
   * Java method: com.neovia.equadvice.data.service.SubClassService.put
   */
  put(arg0: ClassDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`classes`, data: arg0 });
  }
}

@Injectable()
export class SubLevelTranslateServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Get filtered & paged level translates
   * Response code 206 - Partial ranged level translates
   * Response code 404 - Not found
   * HTTP GET /level_translates
   * Java method: com.neovia.equadvice.data.service.SubLevelTranslateService.fetch
   */
  fetch(arg0: TranslateLevelFilterDto): RestResponse<SharedPagedResponse<TranslateLevelDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`level_translates`, data: arg0 });
  }

  /**
   * Patch level translate
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP PATCH /level_translates
   * Java method: com.neovia.equadvice.data.service.SubLevelTranslateService.patch
   */
  patch(arg0: TranslateDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`level_translates`, data: arg0 });
  }
}

@Injectable()
export class SubNutrientRightServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create nutrient right
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /nutrient_rights
   * Java method: com.neovia.equadvice.data.service.SubNutrientRightService.create
   */
  create(queryParams?: { nutrientId?: string; entityCode?: string; }): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`nutrient_rights`, queryParams: queryParams });
  }

  /**
   * Delete nutrient right
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /nutrient_rights
   * Java method: com.neovia.equadvice.data.service.SubNutrientRightService.delete
   */
  delete(queryParams?: { nutrientId?: string; entityCode?: string; }): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`nutrient_rights`, queryParams: queryParams });
  }

  /**
   * Get nutrient rights by entities
   * Response code 206 - Partial ranged nutrientRights
   * Response code 404 - Not found
   * HTTP GET /nutrient_rights/{nutrientId}
   * Java method: com.neovia.equadvice.data.service.SubNutrientRightService.fetch
   */
  fetch(nutrientId: string, arg1: EntityRightFilterDto): RestResponse<SharedPagedResponse<EntityRightDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`nutrient_rights/${nutrientId}`, data: arg1 });
  }
}

@Injectable()
export class SubNutrientPredictionModelServiceClient {

    constructor(protected httpClient: HttpClient) {
    }

    /**
     * Get nutrient prediction models optionnal
     * Response code 206 - Partial ranged nutrient predictionModels
     * Response code 404 - Not found
     * HTTP GET /nutrient_prediction_models
     * Java method: com.neovia.equadvice.data.service.SubNutrientPredictionModelService.fetch
     */
    fetch(nutrientId: string, arg0: PredictionModelFilterDto): RestResponse<SharedPagedResponse<PredictionModelDto>> {
        return this.httpClient.request({ method: 'GET', url: uriEncoding`nutrient_prediction_models/${nutrientId}`, data: arg0 });
    }
}

@Injectable()
export class SubNutrientTranslateServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Get filtered & paged nutrient translates
   * Response code 206 - Partial ranged nutrient translates
   * Response code 404 - Not found
   * HTTP GET /nutrient_translates
   * Java method: com.neovia.equadvice.data.service.SubNutrientTranslateService.fetch
   */
  fetch(arg0: TranslateNutrientFilterDto): RestResponse<SharedPagedResponse<TranslateNutrientDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`nutrient_translates`, data: arg0 });
  }

  /**
   * Patch nutrient translate
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP PATCH /nutrient_translates
   * Java method: com.neovia.equadvice.data.service.SubNutrientTranslateService.patch
   */
  patch(arg0: TranslateDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`nutrient_translates`, data: arg0 });
  }
}

@Injectable()
export class SubPredictionModelRightServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create prediction model right
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /prediction_model_rights
   * Java method: com.neovia.equadvice.data.service.SubPredictionModelRightService.create
   */
  create(queryParams?: { predictionModelId?: string; entityCode?: string; }): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`prediction_model_rights`, queryParams: queryParams });
  }

  /**
   * Delete prediction model right
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /prediction_model_rights
   * Java method: com.neovia.equadvice.data.service.SubPredictionModelRightService.delete
   */
  delete(queryParams?: { predictionModelId?: string; entityCode?: string; }): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`prediction_model_rights`, queryParams: queryParams });
  }

  /**
   * Get prediction model rights by entities
   * Response code 206 - Partial ranged predictionModelRights
   * Response code 404 - Not found
   * HTTP GET /prediction_model_rights/{predictionModelId}
   * Java method: com.neovia.equadvice.data.service.SubPredictionModelRightService.fetch
   */
  fetch(predictionModelId: string, arg1: EntityRightFilterDto): RestResponse<SharedPagedResponse<EntityRightDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`prediction_model_rights/${predictionModelId}`, data: arg1 });
  }
}

@Injectable()
export class SubPredictionModelTranslateServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Get filtered & paged prediction model translates
   * Response code 206 - Partial ranged predictionModel translates
   * Response code 404 - Not found
   * HTTP GET /prediction_model_translates
   * Java method: com.neovia.equadvice.data.service.SubPredictionModelTranslateService.fetch
   */
  fetch(arg0: TranslatePredictionModelFilterDto): RestResponse<SharedPagedResponse<TranslatePredictionModelDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`prediction_model_translates`, data: arg0 });
  }

  /**
   * Patch prediction model translate
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP PATCH /prediction_model_translates
   * Java method: com.neovia.equadvice.data.service.SubPredictionModelTranslateService.patch
   */
  patch(arg0: TranslateDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`prediction_model_translates`, data: arg0 });
  }
}

@Injectable()
export class SubReferenceRightServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Create reference right
   * Response code 201 - Created
   * Response code 500 - Error
   * HTTP POST /reference_rights
   * Java method: com.neovia.equadvice.data.service.SubReferenceRightService.create
   */
  create(queryParams?: { referenceId?: string; entityCode?: string; }): RestResponse<any> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`reference_rights`, queryParams: queryParams });
  }

  /**
   * Delete reference right
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /reference_rights
   * Java method: com.neovia.equadvice.data.service.SubReferenceRightService.delete
   */
  delete(queryParams?: { referenceId?: string; entityCode?: string; }): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`reference_rights`, queryParams: queryParams });
  }

  /**
   * Get reference rights by entities
   * Response code 206 - Partial ranged referenceRights
   * Response code 404 - Not found
   * HTTP GET /reference_rights/{referenceId}
   * Java method: com.neovia.equadvice.data.service.SubReferenceRightService.fetch
   */
  fetch(referenceId: string, arg1: EntityRightFilterDto): RestResponse<SharedPagedResponse<EntityRightDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`reference_rights/${referenceId}`, data: arg1 });
  }
}

@Injectable()
export class SubReferenceTranslateServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Get filtered & paged reference translates
   * Response code 206 - Partial ranged reference translates
   * Response code 404 - Not found
   * HTTP GET /reference_translates
   * Java method: com.neovia.equadvice.data.service.SubReferenceTranslateService.fetch
   */
  fetch(arg0: TranslateReferenceFilterDto): RestResponse<SharedPagedResponse<TranslateReferenceDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`reference_translates`, data: arg0 });
  }

  /**
   * Patch reference translate
   * Response code 204 - Patched
   * Response code 500 - Error
   * HTTP PATCH /reference_translates
   * Java method: com.neovia.equadvice.data.service.SubReferenceTranslateService.patch
   */
  patch(arg0: TranslateDto): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`reference_translates`, data: arg0 });
  }
}

@Injectable()
export class VariableValueServiceClient {

  constructor(protected httpClient: HttpClient) {
  }

  /**
   * Delete variable value
   * Response code 202 - Deleted
   * Response code 500 - Error
   * HTTP DELETE /variable_values/{variableCode}
   * Java method: com.neovia.equadvice.data.service.VariableValueService.delete
   */
  delete(variableCode: string, queryParams?: { value?: string; }): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`variable_values/${variableCode}`, queryParams: queryParams });
  }

  /**
   * Get filtered & paged variableValues
   * Response code 206 - Partial ranged variableValues
   * Response code 404 - Not found
   * HTTP GET /variable_values
   * Java method: com.neovia.equadvice.data.service.VariableValueService.fetch
   */
  fetch(arg0: VariableValueFilterDto): RestResponse<SharedPagedResponse<VariableValueDto>> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`variable_values`, data: arg0 });
  }

  /**
   * Import preview
   * Response code 200 - results
   * Response code 400 - Bad request
   * HTTP POST /variable_values/import/preview
   * Java method: com.neovia.equadvice.data.service.SubVariableValueImportService.importPreview
   */
  importPreview(arg0: VariableValueImportParamsDto): RestResponse<VariableValueImportPreviewDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`variable_values/import/preview`, data: arg0 });
  }

  /**
   * Import variable values
   * Response code 200 - results
   * Response code 400 - Bad request
   * HTTP POST /variable_values/import
   * Java method: com.neovia.equadvice.data.service.SubVariableValueImportService.importValues
   */
  importValues(arg0: VariableValueImportParamsDto): RestResponse<string[]> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`variable_values/import`, data: arg0 });
  }

  /**
   * Patch variable value variable code (rename)
   * Response code 202 - Modified
   * Response code 500 - Error
   * HTTP PATCH /variable_values/variable_code/{oldVariableCode}
   * Java method: com.neovia.equadvice.data.service.VariableValueService.renameVariable
   */
  renameVariable(oldVariableCode: string, queryParams?: { newVariableCode?: string; }): RestResponse<any> {
    return this.httpClient.request({ method: 'PATCH', url: uriEncoding`variable_values/variable_code/${oldVariableCode}`, queryParams: queryParams });
  }
}

@Injectable()
export class ResultColumnService {
  constructor(private readonly httpClient: HttpClient) {
  }

  /**
   * Get result
   * Response code 200 - results
   * Response code 404 - Not found
   * HTTP GET /entities/{entityCode}/raw_materials/{id}/result_column
   * Java method: com.neovia.equadvice.data.service.ResultColumnService.fetchForFeed
   */
   fetchResultsFromRawMat(entityCode: string, rawMatId: string, arg0: DataResultColumnFilterDto): Observable<ResultColumnDto[]> {
    if (!arg0.computeId) {
      /* Shallow copy because we remove a key in object
       * and do not alter the original to let it to the caller */
      arg0 = {...arg0};
      /* Remove it to avoid to send useless parameter which disturbs the back end */
      delete arg0.computeId ;
    }
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/raw_materials/${rawMatId}/result_column`, data: arg0 });
  }

  /**
   * Get result
   * Response code 200 - results
   * Response code 404 - Not found
   * HTTP GET /entities/{entityCode}/samples/{id}/result_column
   * Java method: com.neovia.equadvice.data.service.ResultColumnService.fetchForSample
   */
   fetchResultsFromSample(entityCode: string, sampleId: string, arg0: SampleResultColumnFilterDto): Observable<ResultColumnDto[]> {
    if (!arg0.tempCalculationId) {
      /* Shallow copy because we remove a key in object
       * and do not alter the original to let it to the caller */
      arg0 = {...arg0};
      /* Remove it to avoid to send useless parameter which disturbs the back end */
      delete arg0.tempCalculationId ;
    }
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/samples/${sampleId}/result_column`, data: arg0 });
  }
}

@Injectable()
export class FullAutoImportService {
  constructor(private readonly httpClient: HttpClient) {
  }

  /**
   * Post full auto import creation for RM Feed
   * Response code 204 - import process success
   * Response code 500 - Erreur
   * HTTP POST entities/${entityCode}/import-full-auto
   * Java method: com.neovia.equadvice.data.service.impl.ImportRmFeedFullAutoService.fullAutoImportRawMaterialCreation
   */
   importRmFeedFullAutoCreation(entityCode: string, body: ImportFullAutoDto): RestResponse<string> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities/${entityCode}/import-full-auto`, data: body });
  }

  /**
   * PUT full auto import modification for RM Feed
   * Response code 204 - import process success
   * Response code 500 - Erreur
   * HTTP PUT entities/${entityCode}/import-full-auto
   * Java method: com.neovia.equadvice.data.service.impl.ImportRmFeedFullAutoService.fullAutoImportRawMaterialModification
   */
   importRmFeedFullAutoModification(entityCode: string, body: ImportFullAutoDto): RestResponse<string> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`entities/${entityCode}/import-full-auto`, data: body });
  }

  /**
   * Get full auto import jobs of user
   * Response code 200 - OK
   * Response code 500 - Error
   * HTTP GET /entities/{entityCode}/import-full-auto/{type}
   * Java method: com.neovia.equadvice.data.service.impl.ImportRmFeedFullAutoService.getJobs
   */
  importRmFeedFullAutoGetJobs(entityCode: string, type: string): RestResponse<JobDto[]> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/import-full-auto/${type}` });
  }

  /**
   * Get full auto import result
   * Response code 200 - OK
   * Response code 303 - See status
   * Response code 500 - Error
   * HTTP GET /entities/{entityCode}/import-full-auto/{id}/result
   * Java method: com.neovia.equadvice.data.service.impl.ImportRmFeedFullAutoService.getResult
   */
  importRmFeedFullAutoResultGetResult(entityCode: string, id: string): RestResponse<any> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/import-full-auto/${id}/result` });
  }

  /**
   * Get full auto import status
   * Response code 200 - OK
   * Response code 303 - See result
   * Response code 500 - Error
   * HTTP GET /entities/{entityCode}/import-full-auto/{id}/status
   * Java method: com.neovia.equadvice.data.service.impl.ImportRmFeedFullAutoService.getStatus
   */
  importRmFeedFullAutoStatusGetStatus(entityCode: string, id: string): RestResponse<JobStatusInfo> {
    return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/import-full-auto/${id}/status` });
  }

  /**
   * Delete a calculate batch
   * Response code 204 - Cancel
   * Response code 500 - Error
   * HTTP DELETE /entities/{entityCode}/import-full-auto/{id}
   * Java method: com.neovia.equadvice.data.service.impl.ImportRmFeedFullAutoService.delete
   */
  importRmFeedFullAutoDelete(entityCode: string, id: string): RestResponse<void> {
    return this.httpClient.request({ method: 'DELETE', url: uriEncoding`entities/${entityCode}/import-full-auto/${id}` });
  }

}

export type RestResponse<R> = Observable<R>;

export type TextMatchMode = 'STRICT' | 'CONTAINS';

export type Status = 'STARTED' | 'FAILED' | 'FINISHED' | 'SAVED' | 'UNPROCESSED';

export type HttpStatus = 'CONTINUE' | 'SWITCHING_PROTOCOLS' | 'PROCESSING' | 'CHECKPOINT' | 'OK' | 'CREATED' | 'ACCEPTED' | 'NON_AUTHORITATIVE_INFORMATION' | 'NO_CONTENT' | 'RESET_CONTENT' | 'PARTIAL_CONTENT' | 'MULTI_STATUS' | 'ALREADY_REPORTED' | 'IM_USED' | 'MULTIPLE_CHOICES' | 'MOVED_PERMANENTLY' | 'FOUND' | 'MOVED_TEMPORARILY' | 'SEE_OTHER' | 'NOT_MODIFIED' | 'USE_PROXY' | 'TEMPORARY_REDIRECT' | 'PERMANENT_REDIRECT' | 'BAD_REQUEST' | 'UNAUTHORIZED' | 'PAYMENT_REQUIRED' | 'FORBIDDEN' | 'NOT_FOUND' | 'METHOD_NOT_ALLOWED' | 'NOT_ACCEPTABLE' | 'PROXY_AUTHENTICATION_REQUIRED' | 'REQUEST_TIMEOUT' | 'CONFLICT' | 'GONE' | 'LENGTH_REQUIRED' | 'PRECONDITION_FAILED' | 'PAYLOAD_TOO_LARGE' | 'REQUEST_ENTITY_TOO_LARGE' | 'URI_TOO_LONG' | 'REQUEST_URI_TOO_LONG' | 'UNSUPPORTED_MEDIA_TYPE' | 'REQUESTED_RANGE_NOT_SATISFIABLE' | 'EXPECTATION_FAILED' | 'I_AM_A_TEAPOT' | 'INSUFFICIENT_SPACE_ON_RESOURCE' | 'METHOD_FAILURE' | 'DESTINATION_LOCKED' | 'UNPROCESSABLE_ENTITY' | 'LOCKED' | 'FAILED_DEPENDENCY' | 'UPGRADE_REQUIRED' | 'PRECONDITION_REQUIRED' | 'TOO_MANY_REQUESTS' | 'REQUEST_HEADER_FIELDS_TOO_LARGE' | 'UNAVAILABLE_FOR_LEGAL_REASONS' | 'INTERNAL_SERVER_ERROR' | 'NOT_IMPLEMENTED' | 'BAD_GATEWAY' | 'SERVICE_UNAVAILABLE' | 'GATEWAY_TIMEOUT' | 'HTTP_VERSION_NOT_SUPPORTED' | 'VARIANT_ALSO_NEGOTIATES' | 'INSUFFICIENT_STORAGE' | 'LOOP_DETECTED' | 'BANDWIDTH_LIMIT_EXCEEDED' | 'NOT_EXTENDED' | 'NETWORK_AUTHENTICATION_REQUIRED';

export type JobStatus = 'PENDING' | 'RUNNING' | 'FINISHED' | 'CANCELLED';

export type PatchAction = 'LOCK_ENTITY' | 'UNLOCK_ENTITY' | 'SAVE_NOTES' | 'SAVE_COHERENCE' | 'SAVE_CALCULATION_STATUS';

export type PatchOperation = 'ADD' | 'REMOVE' | 'REPLACE' | 'COPY' | 'MOVE' | 'TEST';

export function uriEncoding(template: TemplateStringsArray, ...substitutions: any[]): string {
  let result = environment.data.baseUrl;
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}


@Injectable()
export class SemiAutoImportHttpService {
  constructor(private readonly httpClient: HttpClient) {
  }

  /**
   * Post semi auto import creation for RM Feed
   * Response code 200 - import process success
   * Response code 500 - Erreur
   * HTTP POST entities/${entityCode}/import-semi-auto
   * Java method: com.neovia.equadvice.data.service.impl.ImportRmFeedSemiAutoService.semiAutoImportRawMaterialCreation
   */
   importRmFeedSemiAutoCreation(entityCode: string, body: RawMaterialSemiautoRequestDto): Observable<RawMaterialSemiautoResponseDto> {
    return this.httpClient.request({ method: 'POST', url: uriEncoding`entities/${entityCode}/import-semi-auto`, data: body });
  }

  /**
   * PUT full auto import modification for RM Feed
   * Response code 204 - import process success
   * Response code 500 - Erreur
   * HTTP PUT entities/${entityCode}/import-semi-auto
   * Java method: com.neovia.equadvice.data.service.impl.ImportRmFeedSemiAutoService.semiAutoImportRawMaterialModification
   */
   importRmFeedSemiAutoModification(entityCode: string, body: RawMaterialSemiautoRequestDto): Observable<RawMaterialSemiautoResponseDto> {
    return this.httpClient.request({ method: 'PUT', url: uriEncoding`entities/${entityCode}/import-semi-auto`, data: body });
  }
}

@Injectable()
export class DataSampleNutrientService {
  constructor(private readonly httpClient: HttpClient) {
  }

  getSampleNutrientByEntityCode(entityCode: string, sampleId: string, forcedRefCode?: string): Observable<SampleNutrientDto[]> {
    return this.httpClient.request({
      method: 'GET',
      url: uriEncoding`entities/${entityCode}/samples/${sampleId}/nutrients`,
      queryParams : forcedRefCode ? { forcedReferenceCode: forcedRefCode } : null
    });
  }

}

@Injectable()
export class SampleResultService {
  constructor(private readonly httpClient: HttpClient){}

  /**
   * Get result
   * Response code 200 - results
   * HTTP GET /entities/{entityCode}/samples/{id}/results
   * Java method: com.neovia.equadvice.data.service.SubResultService.fetchForSample
   */
    fetch(entityCode: string, sampleId: string, arg0: ResultFilterDto): RestResponse<ResultDto[]> {
      return this.httpClient.request({ method: 'GET', url: uriEncoding`entities/${entityCode}/samples/${sampleId}/results`, data: arg0 });
    }
}

export enum SemiautoImportLineStatus {
  OK = "OK",
  ERROR = "ERROR",
  WARNING = "WARNING"
}

export class RawMaterialSemiAutoLineDto {
  lineNumber:number;
  rawMaterial: RawMaterialDto;
  status?: SemiautoImportLineStatus;
  errorMsg?: string;
  inputs: NutrientSemiAutoDto[] = [];
  // used for save RM
  labelOrReferenceModified?: boolean;
  // Only for front
  processed: boolean = false;
}

export class NutrientSemiAutoDto {
  readonly code: string;
  readonly value?: number;

  constructor(code: string, valeur?: number) {
    this.code = code;
    this.value = valeur;
  }
}

// Semi auto import server response
export class RawMaterialSemiautoResponseDto {
  rejected: boolean; // False when full file is rejected
  errorMsg: string; // Error message key when ful file is rejected
  lines: RawMaterialSemiAutoLineDto[] = [];
}

export class RawMaterialSemiautoRequestDto {
  csvContent: string;
}
